import React from 'react';
import ChartRenderer from './ChartRenderer';

const ChatBubble = ({ message, isUser, timestamp }) => {
  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString([], { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <div className={`flex mb-4 ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div className={`flex flex-col ${isUser ? 'items-end max-w-xs lg:max-w-md' : 'items-start w-full'}`}>
        {/* Message bubble */}
        <div
          className={`chat-bubble ${
            isUser ? 'chat-bubble-user' : 'chat-bubble-bot'
          } ${!isUser && message.chartData ? 'max-w-xs lg:max-w-md' : ''}`}
        >
          {message.text && (
            <p className="text-sm whitespace-pre-wrap break-words">
              {message.text}
            </p>
          )}
        </div>

        {/* Chart rendering for bot messages */}
        {!isUser && message.chartData && (
          <div className="mt-2 w-full flex justify-start">
            <ChartRenderer chartData={message.chartData} />
          </div>
        )}

        {/* Timestamp */}
        <span className="text-xs text-gray-400 mt-1 px-2">
          {formatTime(timestamp)}
        </span>
      </div>
    </div>
  );
};

export default ChatBubble;
